(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat-banner/assets/javascripts/bannerprops-handler.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat-banner/assets/javascripts/bannerprops-handler.js');
"use strict";


const {
  useState,
  useEffect
} = React;
const logger = svs.core.log.getLogger('sport:sportinfo-bigstat');
const {
  OutcomeToAlphabeticStrings,
  EventTypes
} = svs.components.sportinfo.common.constants;
const {
  ResultTypes,
  helpers
} = svs.components.sport.sportEventCommon;
const {
  ApiProxy
} = svs.components.lbUtils.apiProxy;
const {
  customSporteventApiHandler
} = svs.components.sportinfo.common.helpers;
const BannerpropsHandler = _ref => {
  let {
    matchId,
    productId,
    children
  } = _ref;
  const [isLoading, setIsLoading] = useState(true);
  const [bannerprops, setBannerprops] = useState({});
  useEffect(() => {
    let isActive = true;
    setIsLoading(true);
    const apiProxy = new ApiProxy([customSporteventApiHandler]);
    (async () => {
      try {
        const eventPromise = apiProxy.fetch("/sport/1/sportevent/".concat(matchId), {
          method: 'GET',
          productId
        });
        const oddsPromise = new Promise((resolve, reject) => {
          svs.core.jupiter.get("/sport/2/sportevent/".concat(matchId, "/odds"), resolve, reject);
        });
        const [eventResponse, oddsResponse] = await Promise.all([eventPromise, oddsPromise]);
        if (eventResponse) {
          const {
            participants,
            league,
            sport,
            startTime,
            results,
            status: sportEventStatus,
            statusTime
          } = eventResponse.sportEvent;
          let odds = null;
          if (oddsResponse) {
            const oddsType = oddsResponse.eventTypes.find(et => et.eventType === EventTypes.EventType1X2);
            const oddsToParse = oddsType !== null && oddsType !== void 0 && oddsType.odds.length ? oddsType === null || oddsType === void 0 ? void 0 : oddsType.odds : oddsType === null || oddsType === void 0 ? void 0 : oddsType.startOdds;
            if (oddsToParse !== null && oddsToParse !== void 0 && oddsToParse.length) {
              odds = oddsToParse.reduce((acc, curr) => {
                acc[OutcomeToAlphabeticStrings[curr.outcome]] = curr.value;
                return acc;
              }, {});
            }
          }
          if (isActive) {
            setBannerprops({
              homeTeam: participants[0],
              awayTeam: participants[1],
              leagueName: league.name,
              sportType: sport.sportType,
              startTime,
              results: helpers.getCurrentResult(results) || results.find(result => result.type === ResultTypes.Fulltime),
              odds,
              sportEventStatus,
              statusTime
            });
          }
        }
        if (isActive) {
          setIsLoading(false);
        }
      } catch (error) {
        logger.warn("Failed to fetch match with id ".concat(matchId, ": ").concat(error));
        if (isActive) {
          setIsLoading(false);
        }
      }
    })();
    return () => {
      isActive = false;
    };
  }, [matchId, productId]);
  return children(bannerprops, isLoading);
};
BannerpropsHandler.propTypes = {
  children: PropTypes.func.isRequired,
  matchId: PropTypes.number.isRequired
};
setGlobal('svs.components.sportInfo.bigStatBanner.BannerpropsHandler', BannerpropsHandler);

 })(window);